export enum CustomerDisplayCartLayoutType {
  FULL = "FULL",
  SPLIT = "SPLIT",
}
